import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, provideHttpClient, withFetch, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { MsalAuthModule } from './msal.module';
import { MsalInterceptor } from '@azure/msal-angular';
import { ErrorHandler } from '@angular/core';
import { GlobalErrorHandler } from './global-error-handler';
import { httpRetryInterceptor } from './core/interceptors/http-retry.interceptor';

const isBrowser = typeof window !== 'undefined';
const browserOnlyMsalProviders = isBrowser
  ? [
      importProvidersFrom(MsalAuthModule),
      { provide: HTTP_INTERCEPTORS, useClass: MsalInterceptor, multi: true },
    ]
  : [];

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideClientHydration(),
    provideHttpClient(
      withInterceptorsFromDi(),
      withInterceptors([httpRetryInterceptor]),
      withFetch()
    ),
    provideAnimationsAsync(),
    ...browserOnlyMsalProviders,
    { provide: ErrorHandler, useClass: GlobalErrorHandler }
  ]
};


